import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useMediaQuery,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PublicEventNavigation } from "./PublicEventNavigation";

interface Props {
  navigateToInfo: () => void;
  navigateToProcedure: () => void;
  navigateToSummary: () => void;
}

export const MobileStepDrawer = ({ navigateToInfo, navigateToProcedure, navigateToSummary }: Props) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const { t } = useTranslation();

  const closeAndNavigate = (navigate: () => void) => () => {
    setShowDrawer(false);
    navigate();
  };

  if (isLargerThan768) return null;

  return (
    <>
      <Drawer placement="bottom" onClose={() => setShowDrawer(false)} isOpen={showDrawer}>
        <DrawerOverlay />
        <DrawerContent borderTop="1px solid" borderColor="smBorder">
          <DrawerBody py="4">
            <PublicEventNavigation
              navigateToInfo={closeAndNavigate(navigateToInfo)}
              navigateToProcedure={closeAndNavigate(navigateToProcedure)}
              navigateToSummary={closeAndNavigate(navigateToSummary)}
            />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Flex
        position="fixed"
        zIndex={1}
        bottom="0px"
        width="full"
        height="60px"
        borderTop="1px solid"
        borderColor="smBorder"
        alignItems="center"
        bg="smBackground"
      >
        <Button
          variant="solid"
          colorScheme="teal"
          width="full"
          ml="10px"
          mr="10px"
          onClick={() => setShowDrawer(true)}
        >
          {t("Change step")}
        </Button>
      </Flex>
    </>
  );
};
